module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 _.each(groups, function(group) { 
__p+='\n	<div class="group tag_group_'+
((__t=( group.id ))==null?'':__t)+
'">\n		<h4>'+
((__t=( group.name ))==null?'':__t)+
'</h4>\n		';
 var visible_count = 0; 
__p+='\n		';
 _.each(group.tags, function(tag, i) { 
__p+='\n			';
 i = i + 1 
__p+='\n			';
 visible_count++; 
__p+='\n\n			<span data-id="'+
((__t=( tag.id ))==null?'':__t)+
'"\n				data-group="'+
((__t=( group.name ))==null?'':__t)+
'"\n				class="tag '+
((__t=( tag.count === 0 ? 'disabled' : '' ))==null?'':__t)+
' '+
((__t=( i > 99 ? 'hidden' : '' ))==null?'':__t)+
'">\n				<input type="checkbox" name="tags" value="'+
((__t=( tag.id ))==null?'':__t)+
'" id="tag_'+
((__t=( tag.id ))==null?'':__t)+
'" class="checkbox" '+
((__t=( isSelected(tag.id) ? 'checked' : '' ))==null?'':__t)+
' />\n				<label for="tag_'+
((__t=( tag.id ))==null?'':__t)+
'">\n					'+
((__t=( tag.tag ))==null?'':__t)+
'\n					';
 if ( tag.count !== null ) { 
__p+='\n						';
 if ( tag.count > 0 ) { 
__p+='\n							<span class="count">'+
((__t=( tag.count ))==null?'':__t)+
'</span>\n							';
 } 
__p+='\n							';
 } 
__p+='\n						</label>\n						<br/>\n					</span>\n\n					';
 }) 
__p+='\n\n		';
 if ( visible_count > 99 ) { 
__p+='\n			<span class="more" data-group="'+
((__t=( group.id ))==null?'':__t)+
'">\n				Mehr\n			</span>\n			';
 } 
__p+='\n\n	</div>\n';
 }) 
__p+='\n';
}
return __p;
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/mitch/jsapps/modules/reserva/templates/browser/SidebarTemplate.html
 ** module id = 65
 ** module chunks = 0
 **/